import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { showChatButton } from '../lib/buttons';
import { getTranslation } from '../../constants/languages';
import { ChatBubbleOutlined } from '../common/svgicons/ChatBubbleOutlined';

type ChatMenuButtonProps = {
    iimclient: ConfigClientType;
    toggleMenu: Function;
};

const Translations = {
    lang_no: 'Åpne chat',
    lang_se: 'Öppna chattaalternativ',
    lang_fi: 'Avaa chat-vaihtoehto',
    lang_dk: 'Åben chatfunktion',
    lang_en: 'Open chat option',
};

const ChatMenuButton = ({ iimclient, toggleMenu }: ChatMenuButtonProps) => {
    const { lang } = iimclient;
    const showChat = () => {
        if ((window as any).vngage?.showChatBanner) {
            (window as any).vngage.showChatBanner(); // set by custom script
        }
        toggleMenu('chat');
    };
    const handleClick = () => showChat();
    const handleKeyDown = ({ keyCode }) => (keyCode === 13 || keyCode === 32) && showChat();
    const translation = getTranslation(lang, Translations);

    return (
        showChatButton(iimclient) && (
            <div
                id="chat-menu-button"
                className="content-button action chat-button"
                tabIndex={0}
                role="menuitem"
                aria-label={translation}
                onClick={handleClick}
                onKeyDown={handleKeyDown}
            >
                <ChatBubbleOutlined width="24px" height="24px" />
            </div>
        )
    );
};

export default ChatMenuButton;
